import { useState } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      quote: 'Vertak Group brought professionalism and on-time delivery to our infrastructure project. Their attention to detail and commitment to excellence exceeded our expectations.',
      author: 'Leading Real Estate Partner',
      role: 'Infrastructure Development'
    },
    {
      quote: 'Their mining advisory helped optimize our operations significantly. The team\'s expertise and strategic insights have been invaluable to our business growth.',
      author: 'Mining Industry Client',
      role: 'Mining Operations'
    },
    {
      quote: 'Working with Vertak Group on our commercial project was seamless. They delivered exceptional quality while maintaining strict timelines and budget constraints.',
      author: 'Corporate Client',
      role: 'Commercial Construction'
    }
  ];

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Client Testimonials</h2>
          <div className="w-24 h-1 bg-[#C9A961] mx-auto mb-6"></div>
          <p className="text-gray-600 text-lg">
            Hear what our clients say about working with us
          </p>
        </div>

        <div className="relative">
          <div className="bg-white p-12 rounded-2xl shadow-xl">
            <i className="ri-double-quotes-l text-5xl text-[#C9A961] mb-6 block"></i>
            <p className="text-gray-700 text-lg leading-relaxed mb-8 italic">
              {testimonials[currentIndex].quote}
            </p>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-900 font-bold text-lg">{testimonials[currentIndex].author}</p>
                <p className="text-gray-500 text-sm">{testimonials[currentIndex].role}</p>
              </div>
              <div className="flex gap-3">
                <button
                  onClick={prevSlide}
                  className="w-12 h-12 bg-gray-100 hover:bg-[#C9A961] text-gray-600 hover:text-white rounded-full flex items-center justify-center transition-all cursor-pointer"
                >
                  <i className="ri-arrow-left-s-line text-xl"></i>
                </button>
                <button
                  onClick={nextSlide}
                  className="w-12 h-12 bg-gray-100 hover:bg-[#C9A961] text-gray-600 hover:text-white rounded-full flex items-center justify-center transition-all cursor-pointer"
                >
                  <i className="ri-arrow-right-s-line text-xl"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  index === currentIndex ? 'bg-[#C9A961] w-8' : 'bg-gray-300'
                }`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}